<template>
    <div class="wrapper">
        <div class="splash">
            <div class="parallax">
                <div class="logo back"></div>
                <div class="logo front"></div>
            </div>
            <div class="h2"><div class="inset bg-alt text-bg">Ubercharged Gaming</div></div>
            <div>
                <div style="margin: 10px">Coming soon&#8482;</div>
                <a class="button" href="https://discord.gg/0140zAqXoEaHJKmnX">Discord</a>
                <a class="button" href="https://steamcommunity.com/groups/ubrgmg">Steam</a>
            </div>
        </div>
    </div>
</template>

<script>
var jQuery = require('jquery')

export default {
    mounted () {
        jQuery(document).mousemove(event => {
            this.mouseMove(event.pageX, event.pageY)
        })
    },
    data () {
        return {
        }
    },
    methods: {
        mouseMove: (mouseX, mouseY) => {
            var logo = jQuery('.parallax')
            var offset = logo.offset()

            var centerX = offset.left + logo.width() / 2
            var centerY = offset.top + logo.height() / 2

            var deltaX = mouseX - centerX
            var deltaY = mouseY - centerY

            var rotateX = deltaX / jQuery(window).width() * 45
            var rotateY = deltaY / jQuery(window).height() * 45

            if (rotateX < 0) {
                rotateX = 360 + rotateX
            }

            if (rotateY < 0) {
                rotateY = 360 + rotateY
            }

            logo.css(
                'transform',
                'rotate3d(1, 0, 0, ' + -rotateY + 'deg) rotate3d(0, 1, 0, ' + rotateX + 'deg)'
            )
        }
    }
}
</script>

<style scoped lang="scss">
@import '../scss/variables';

$logoWidth: 250px;
$logoHeight: 347px;
$frontPop: 100px;

.wrapper {
    width: 100%;
    height: 100%;
    
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;

    perspective: 4000px;
    -webkit-perspective: 4000px;
}

.splash {
    transform-style: preserve-3d;
    -webkit-transform-style: preserve-3d;
    -moz-transform-style: preserve-3d;

    .parallax {
        width: $logoWidth;
        height: $logoHeight;
        margin: auto;
        padding-bottom: 50px;
        transform-style: preserve-3d;
        -webkit-transform-style: preserve-3d;
        -moz-transform-style: preserve-3d;

        .logo {
            width: 100%;
            height: 100%;
            position: absolute;

            &.front {
                transform: translateZ($frontPop);
                background: url('../assets/logo-primary.png') no-repeat;
            }

            &.back {
                background: url('../assets/logo.png') no-repeat;
            }
        }
    }

    .h2 {
        text-transform: uppercase;

        .inset {
            padding: 5px 8px;
            display: inline-block;
        }
    }
}
</style>



// WEBPACK FOOTER //
// Home.vue?506c07ca